import { c as _c } from "react/compiler-runtime";
import { keysOf } from 'betterplace-utils';
import { useMemo } from 'react';
import { useNativePaymentMethodsContext } from '../NativePaymentMethodsContext';
function useNativePaymentMethodsAreAvailable() {
  const $ = _c(2);
  const {
    loading,
    available
  } = useNativePaymentMethodsContext();
  let t0;
  if ($[0] !== available) {
    t0 = keysOf(available).find(key => available[key]);
    $[0] = available;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const anyAvailable = !!t0;
  return !loading && anyAvailable;
}
export default useNativePaymentMethodsAreAvailable;